import React from 'react';
import {
    TextField,
    InputAdornment,
    IconButton,
    Tooltip
} from '@mui/material';
import { MdSearch, MdClose } from 'react-icons/md';

const CrmFileField = (props) => {
    const {
        name,
        label,
        value,
        inputProps,
        onChange,
        disabled,
        tooltip,
        helperText,
        errorMsg,
        required,
        autoComplete = 'on',
        onSelectFileClicked,
        onClearClick,
        isEditableField
    } = props;

    const textField = <TextField
        label={label}
        name={name}
        value={value ?? ""}
        type='text'
        inputProps={{
            ...inputProps,
        }}
        onChange={onChange}
        fullWidth
        disabled={true}
        size="small"
        error={Boolean(errorMsg)}
        helperText={errorMsg || helperText}
        autoComplete={autoComplete}
        required={required}
        InputProps={{
            endAdornment: (
                <InputAdornment position="end" sx={{ gap: 0.5 }}>
                    {value && !disabled && isEditableField && (
                        <IconButton
                            size="small"
                            onClick={() => onClearClick(name)}//TODO:
                        >
                            <MdClose />
                        </IconButton>
                    )}
                    {isEditableField &&
                        <IconButton
                            size="small"
                            onClick={() => onSelectFileClicked(name)}//TODO:
                            disabled={disabled}
                        >
                            <MdSearch />
                        </IconButton>
                    }
                </InputAdornment>
            ),
        }}
    />

    return tooltip ? (
        <Tooltip title={tooltip} arrow placement="top">
            {textField}
        </Tooltip>
    ) : (
        textField
    );
};

export default CrmFileField;
